import styles from "./DiscountedBookingsTooltip.module.css";

export type DiscountedBookingsTooltipRow = {
  name: string;
  value: string;
  color: string;
};

export type DiscountedBookingsTooltipProps = {
  title: string;
  rows: DiscountedBookingsTooltipRow[];
  totalLabel: string;
  totalValue: string;
};

export const DiscountedBookingsTooltip = ({ title, rows, totalLabel, totalValue }: DiscountedBookingsTooltipProps) => (
  <div className={styles.tooltip}>
    <div className={styles.title}>{title}</div>
    <div className={styles.rows}>
      {rows.map(({ name, value, color }) => (
        <div key={name} className={styles.row}>
          <span className={styles.marker} style={{ backgroundColor: color }} />
          <span className={styles.name}>{name}</span>
          <span className={styles.value}>{value}</span>
        </div>
      ))}
    </div>
    <div className={styles.total}>
      <span className={styles.name}>{totalLabel}</span>
      <span className={styles.value}>{totalValue}</span>
    </div>
  </div>
);
